import * as React from 'react';
import PropTypes from 'prop-types';
import MuiTypography from '@mui/material/Typography';

/**
 * variant と実際の HTML タグの対応。
 * 見出しの飾りライン（旧 marked プロパティ）は廃止した。
 */
const variantMapping = {
  h1: 'h1',
  h2: 'h1',
  h3: 'h1',
  h4: 'h1',
  h5: 'h3',
  h6: 'h2',
  subtitle1: 'h3',
};

function Typography(props) {
  const { children, variant, ...other } = props;

  return (
    <MuiTypography variantMapping={variantMapping} variant={variant} {...other}>
      {children}
    </MuiTypography>
  );
}

Typography.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
};

export default Typography;
